module.exports = __webpack_public_path__ + "static/Fanhome_Popup_Newsletter_MOBILE-270b821938cacef9ff2d4c93fb397a53.png";